import {FormControl} from "react-bootstrap";
import React, {useEffect, useState} from "react";

export const ServiceDrivenDropDownFieldEditor = (Service) => {
	
	if(!Service) {
		debugger;
	}
	
	return (props) => {
	
		const {Value, OnUpdate, FieldDef, CustomData} = props;
		const {
			className = null,
			value = Value,
			onChange = OnUpdate,
			fieldDef = FieldDef,
			customData = CustomData,
			additionalOptions = [],
			context = false
		} = props;
		
		const {organizationId = null, contextNodeId = null} = context ?? {};
		const [models, setModels] = useState(null);
	
		const updateModels = (response) => {
			setModels(response?.result || []);
		};
	
		useEffect(() => {
			if(context !== false) {
				Service.GetWithContext({organizationId, contextNodeId})
					.then(updateModels)
			} else {
				Service.Get()
					.then(updateModels)
			}
		}, [organizationId, contextNodeId]);
	
	
		const modelOptions = models?.map(model => ({
			key: Service.GetPrimaryKey(model),
			value: Service.GetPrimaryKey(model),
			title: Service.GetTitle(model),
		})) ?? [];
	
		let options = [
			...additionalOptions,
			...modelOptions,
		];
	
		let defaultValue = null;
		if(options.find(m => String(m.value) === String(value)) === undefined && options?.[0]?.value != null) {
			// onChange(options[0]?.value);
			defaultValue = String(options[0]?.value);
		}
		
		useEffect(() => {
			if(defaultValue != null && value == null) {
				onChange(defaultValue);
			}
		}, [defaultValue]);
	
		return <FormControl
			as="select"
			className={className}
			placeholder={"Select A " + Service.ModelName}
			value={String(value ?? defaultValue)}
			onChange={x => onChange(x?.target?.value)}
		>
			{
				(models === null) &&
				<option key='0' value='0'>
					Loading...
				</option>
			}
			{
				options.map(option => {
					return <option key={option?.key ?? option?.value} value={option?.value}>
						{option?.title ?? option?.value}
					</option>;
				}) ?? null
			}
		</FormControl>;
	};
};

